/* @flow */

import debounce from 'lodash/debounce';
import { type AxiosPromise } from 'axios';
import { NIVEL_CLIENTE } from '../../usuario/constants';
import grid from '../../grid-preact';
import { type StateGridClientes } from './types';
import { type GetState, type State } from '../../preact-app/types';
import { type Usuario } from '../../usuario/types';
import { PAGINA_INICIAL } from '../../utils/constants';
import buscarUsuarios from '../../usuario/buscar-usuarios';

const FILTRAR_QUERY = 'balcao/grid-clientes/FILTRAR_QUERY';

type Action =
    | {
        type: 'balcao/grid-clientes/FILTRAR_QUERY',
        query: string,
    };

const filtrarQuery = (query: string) => ({
    type: FILTRAR_QUERY,
    query,
});

// Selectors

export const getGridClientes = (state: State) => state.balcao.gridClientes;

const {
    reducer: gridReducer,
    actions: {
        proximaPagina,
        alterarQuantidade,
        voltarPagina,
        alterarOrdem,
        alterarItens,
        pesquisar,
        pesquisarSetAtalhos,
    },
} = grid({
    namespace: 'balcao/grid-clientes',
    getGrid: getGridClientes,
    pesquisar: () => (
        dispatch: Function,
        getState: GetState,
    ): AxiosPromise<Usuario[]> => {
        const {
            ordenacao,
            quantidade,
            pagina,
            query,
        } = getGridClientes(getState());

        return buscarUsuarios({
            ordenacao,
            quantidade,
            pagina,
            query,
            nivel: NIVEL_CLIENTE,
        })
            .then(({ data: { data } }) => dispatch(alterarItens(data)));
    },
});

export {
    proximaPagina,
    alterarQuantidade,
    voltarPagina,
    alterarOrdem,
    pesquisar,
    pesquisarSetAtalhos,
};

export const filtrarQueryPesquisar = (() => {
    const pesquisaDebounced = debounce(dispatch => dispatch(pesquisar()), 300);

    return (query: string) => (dispatch: Function) => {
        dispatch(filtrarQuery(query));
        pesquisaDebounced(dispatch);
    };
})();

const initialState = {
    pagina: PAGINA_INICIAL,
    quantidade: 10,
    ordenacao: 'id DESC',
    query: '',
    permitirProximaPagina: true,
    itens: [],
};

const gridClientesReducer = (state: StateGridClientes = initialState, action: Action) => {
    switch (action.type) {
    case FILTRAR_QUERY:
        return {
            ...state,
            query: action.query,
            pagina: PAGINA_INICIAL,
        };
    default:
        return gridReducer(state, action);
    }
};

export default gridClientesReducer;
